module.exports = __webpack_public_path__ + "static/media/chat-grey-icon.44781a7d.svg";